/**
 * Tâche 1435 (Eric 2026-10-02) — Source UNIQUE des formats de documents
 * texte acceptés à l'import.
 *
 * Avant, la liste vivait en DEUX copies côté navigateur
 * (`TextDocsBulkImportZone.js` et `UploadTextPage.js`) et une troisième au
 * serveur (`routers/text_documents.py::ACCEPTED_EXTS`). En élargir une seule
 * donne le pire des cas : l'écran accepte le fichier, puis le serveur le
 * refuse en 400 — un recul par rapport au message actuel, qui au moins
 * prévient tout de suite. C'est le défaut 1421 (cinq écrans, cinq copies
 * d'une même table).
 *
 * ⚠️ Cette liste DOIT rester alignée sur `ACCEPTED_EXTS` au serveur. Un test
 * (`1435_formats_import.test.js`) compare les deux et échoue si elles
 * divergent.
 */
export const EXTENSIONS_DOC = [".txt", ".md", ".docx", ".pdf", ".xlsx", ".pptx", ".png"];

/**
 * Étape 2/3 de 1435 — Les sources de RÉFÉRENCE, dont la portée est bornée par
 * Eric à titre + étiquettes + synthèse : « pas de Q&R, ni de procédure ou
 * scripts ou objections ». L'écran ne doit donc PAS lancer les Q&R après leur
 * import — il appellerait un pipeline qui refuse (le garde vit au serveur,
 * `core/portee_connaissances.py`) et afficherait une erreur sans faute.
 */
export const EXTENSIONS_PORTEE_REDUITE = [".png"];

/** Les connaissances permises sur une source de référence (URL, image). */
export const PORTEE_REFERENCE = ["titre", "tags", "synthese", "concepts"];

/** Valeur de l'attribut `accept` d'un `<input type="file">`. */
export const ACCEPT_DOC = EXTENSIONS_DOC.join(",");

/** « .txt, .md, .docx, .pdf, .xlsx, .pptx, .png » — pour les phrases d'aide. */
export const LISTE_DOC = EXTENSIONS_DOC.join(", ");

/** Le nom du fichier porte-t-il une extension acceptée ? */
export function extensionAcceptee(nom) {
  const bas = (nom || "").toLowerCase();
  return EXTENSIONS_DOC.some((ext) => bas.endsWith(ext));
}

/** Ce fichier est-il une source de référence (portée bornée) ? */
export function porteeReduite(nom) {
  const bas = (nom || "").toLowerCase();
  return EXTENSIONS_PORTEE_REDUITE.some((ext) => bas.endsWith(ext));
}

/**
 * Le document (tel que renvoyé par le serveur) autorise-t-il cette
 * connaissance ? Pas de marqueur ⇒ document complet, comme avant 1435.
 */
export function connaissanceAutorisee(doc, connaissance) {
  const portee = doc?.connaissances_autorisees;
  if (!portee || portee.length === 0) return true;
  return portee.includes(connaissance);
}
